import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownService } from 'src/app/metricas/service/dropdown-metricas.service';
import { environment } from 'src/environments/environment';
import { FiltrosRegioesService } from './filtros-regioes.service';

export interface States {
  stateId: number;
  stateDescription: string;
}

export interface Region {
  regionId: number;
  regionDescription: string;
}

@Component({
  selector: 'app-filtro-estado-cidade',
  standalone: true,
  templateUrl: './filtro-estado-cidade.component.html',
  styleUrls: ['./filtro-estado-cidade.component.scss'],
  imports: [CommonModule, FormsModule],
})
export class FiltroEstadoCidadeComponent implements OnInit {
  mostrarRegioes = false;
  regionIdSelecionada: number = 0;
  states: States[] = [];
  cities: any[] = [];
  regions: Region[] = [];

  @Output() regiaoChange = new EventEmitter<Region | null>();
  @Output() estadoChange = new EventEmitter<States | null>();
  @Output() cidadesChange = new EventEmitter<any[]>();
  @Output() filtroAtualizado = new EventEmitter<void>();

  mostrarEstados = false;
  mostrarCidades = false;
  estadoSelecionado: States | null = null;
  cidadesSelecionadas: any[] = [];
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  regionSelecionada: Region | null = null;

  mostrarMsgSelecioneRegiao = false;
  mostrarMsgSelecioneEstado = false;

  constructor(
    private _filtrosRegiao: FiltrosRegioesService,
    private dropdownService: DropdownService
  ) {}

  ngOnInit() {
    this.regionIdSelecionada = 0;
    this.filterRegion();
    this.dropdownService.getActiveDropdown().subscribe((active) => {
      if (active !== 'estado') this.mostrarEstados = false;
      if (active !== 'cidade') this.mostrarCidades = false;
      if (active !== 'regiao') this.mostrarRegioes = false;
    });
  }

  onAbrirEstados() {
    if (!this.regionSelecionada) {
      this.mostrarMsgSelecioneRegiao = true;
      setTimeout(() => (this.mostrarMsgSelecioneRegiao = false), 2000);
      return;
    }
    this.toggleEstados();
  }

  onAbrirCidades() {
    if (!this.estadoSelecionado) {
      this.mostrarMsgSelecioneEstado = true;
      setTimeout(() => (this.mostrarMsgSelecioneEstado = false), 2000);
      return;
    }
    this.toggleCidades();
  }

  filterState(regionId: number = 0): void {
    this._filtrosRegiao.listState(regionId).subscribe((states) => {
      this.states = states.data;
    });
  }

  filterRegion(): void {
    this._filtrosRegiao.listRegions().subscribe((response) => {
      this.regions = response.data;

      this.regionSelecionada = null;
      this.regionIdSelecionada = 0;
      this.filterState(0);
    });
  }
  onRegiaoSelecionada(regiao: Region | null) {
    if (regiao) {
      this.regionSelecionada = regiao;
      this.regionIdSelecionada = regiao.regionId;
    } else {
      this.regionSelecionada = null;
      this.regionIdSelecionada = 0;
      this.estadoSelecionado = null;
      this.cidadesSelecionadas = [];
      this.cities = [];
    }
    this.dropdownService.setActiveDropdown('regiao');
    this.mostrarRegioes = false;
    this.estadoSelecionado = null;
    this.cidadesSelecionadas = [];
    this.cities = [];
    this.filterState(this.regionIdSelecionada);
    this.regiaoChange.emit(this.regionSelecionada);
    this.filtroAtualizado.emit();
  }

  filterCitiesByState(stateId: number): void {
    this._filtrosRegiao.listCities(stateId).subscribe((response) => {
      this.cities = response.data;
    });
  }

  onEstadoSelecionado(estado: States | null) {
    this.estadoSelecionado = estado;
    this.cidadesSelecionadas = [];
    if (estado) {
      this.filterCitiesByState(estado.stateId);
      this.estadoChange.emit(estado);
    } else {
      this.cities = [];
      this.cidadesSelecionadas = [];
    }
    this.mostrarCidades = false;
    this.filtroAtualizado.emit();
  }

  toggleEstados() {
    if (!this.regionSelecionada) return;
    if (!this.mostrarEstados) this.dropdownService.setActiveDropdown('estado');
    this.mostrarEstados = !this.mostrarEstados;
  }

  toggleCidades() {
    if (!this.estadoSelecionado) return;
    if (!this.mostrarCidades) this.dropdownService.setActiveDropdown('cidade');
    this.mostrarCidades = !this.mostrarCidades;
  }

  limparEstado() {
    this.onEstadoSelecionado(null);
    this.estadoChange.emit(null);
    this.filtroAtualizado.emit();
    this.mostrarEstados = false;
  }

  limparCidades() {
    this.cidadesSelecionadas = [];
    this.cidadesChange.emit([]);
    this.filtroAtualizado.emit();
    this.mostrarCidades = false;
  }

  get cidadesSelecionadasLabel(): string {
    if (!this.cidadesSelecionadas || !this.cidadesSelecionadas.length)
      return 'Todas as cidades';
    if (this.cidadesSelecionadas.length === 1) {
      return this.cidadesSelecionadas[0].cityDescription;
    }
    return `${this.cidadesSelecionadas.length} cidades selecionadas`;
  }

  onCidadeChange(event: any, cidade: any) {
    const checked = event.target && (event.target as HTMLInputElement).checked;
    if (checked) {
      if (!this.cidadesSelecionadas.includes(cidade)) {
        this.cidadesSelecionadas.push(cidade);
      }
    } else {
      const idx = this.cidadesSelecionadas.indexOf(cidade);
      if (idx > -1) {
        this.cidadesSelecionadas.splice(idx, 1);
      }
    }
    this.cidadesChange.emit([...this.cidadesSelecionadas]);
  }
}
